"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var escape_html_1 = __importDefault(require("escape-html"));
var slate_1 = require("slate");
var RichTextPreview_1 = require("../RichTextPreview");
var postcss_1 = __importDefault(require("postcss"));
var postcssJs = require('postcss-js');
function toCss(style) {
  return __awaiter(this, void 0, void 0, function () {
    var result, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, postcss_1.default().process(style, {
            parser: postcssJs
          })];
        case 1:
          result = _a.sent();
          return [2 /*return*/, result.css];
        case 2:
          err_1 = _a.sent();
          console.warn('convert to css error!');
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/, ''];
      }
    });
  });
}
function serialize(node) {
  return __awaiter(this, void 0, void 0, function () {
    var style, css, string, result, children, _a, imageStyle, imgCss;
    var _this = this;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          style = {}, css = '';
          if (!slate_1.Text.isText(node)) return [3 /*break*/, 2];
          style = RichTextPreview_1.extractStyle(node);
          return [4 /*yield*/, toCss(style)];
        case 1:
          css = _b.sent();
          string = escape_html_1.default(node.text);
          return [2 /*return*/, "<span style=\"" + css + "\">" + string + "</span>"];
        case 2:
          return [4 /*yield*/, Promise.all(node.children.map(function (n) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, serialize(n)];
                  case 1:
                    return [2 /*return*/, _a.sent()];
                }
              });
            });
          }))];
        case 3:
          result = _b.sent();
          children = result.join('');
          style = RichTextPreview_1.extractStyle(node);
          return [4 /*yield*/, toCss(style)];
        case 4:
          css = _b.sent();
          _a = node.type;
          switch (_a) {
            case 'blockquote':
              return [3 /*break*/, 5];
            case 'h1':
              return [3 /*break*/, 6];
            case 'h2':
              return [3 /*break*/, 7];
            case 'li':
              return [3 /*break*/, 8];
            case 'ul':
              return [3 /*break*/, 9];
            case 'ol':
              return [3 /*break*/, 10];
            case 'a':
              return [3 /*break*/, 11];
            case 'img':
              return [3 /*break*/, 12];
            case 'youtube':
              return [3 /*break*/, 14];
            case 'html':
              return [3 /*break*/, 15];
          }
          return [3 /*break*/, 16];
        case 5:
          return [2 /*return*/, "<blockquote style=\"" + css + "\">" + children + "</blockquote>"];
        case 6:
          return [2 /*return*/, "<h1 style=\"" + css + "\">" + children + "</h1>"];
        case 7:
          return [2 /*return*/, "<h2 style=\"" + css + "\">" + children + "</h2>"];
        case 8:
          return [2 /*return*/, "<li style=\"" + css + "\">" + children + "</li>"];
        case 9:
          return [2 /*return*/, "<ul style=\"" + css + "\">" + children + "</ul>"];
        case 10:
          return [2 /*return*/, "<ol style=\"" + css + "\">" + children + "</ol>"];
        case 11:
          return [2 /*return*/, "<a href=\"" + escape_html_1.default(node.href) + "\">" + children + "</a>"];
        case 12:
          imageStyle = {
            maxWidth: style.maxWidth
          };
          if (style.width) {
            imageStyle.width = style.width;
          }
          return [4 /*yield*/, toCss(imageStyle)];
        case 13:
          imgCss = _b.sent();
          return [2 /*return*/, "<p style=\"" + css + "\"><img src=\"" + escape_html_1.default(node.src) + "\" alt=\"article image\" style=\"" + imgCss + "\" /><span>" + children + "</span></p>"];
        case 14:
          return [2 /*return*/, "<div style=\"position: relative; padding-top: " + 9 / 16 * 100 + "%;\" ><iframe title=\"YouTube Player\" src=\"" + escape_html_1.default(node.src) + "\" style=\"position: absolute; left: 0; top: 0; width: 100%; height: 100%;\" /> " + children + " </div>"];
        case 15:
          return [2 /*return*/, "<div style=\"display: block;\"> " + node.value + " </div>"];
        case 16:
          return [2 /*return*/, "<p  style=\"" + css + "\"> " + children + " </p>"];
      }
    });
  });
}
exports.default = serialize;